<template>
  <v-list class="pb-0 mb-0" three-line subheader avatar color="#fafafa">
    <v-divider v-if="index > 0" inset />
    <v-list-item
      @click="click_item"
      :style="item.sender_type !== 'admin' ? 'background: #065a961c;' : ''"
      class="px-1 pa-0 ma-0"
    >
      <v-row no-gutters dense align="center">
        <v-col @click="select_user(item)" cols="2">
          <v-avatar
            size="43"
            v-if="avatar(item)"
            :color="colors[Math.ceil(Math.random() * 4)]"
          >
            <h3 dark class="white--text">
              {{
                item.contact[0].toUpperCase() + item.contact[1].toUpperCase()
              }}
            </h3>
          </v-avatar>
          <v-avatar v-else>
            <v-icon size="45" color="gray darken-1">
              mdi-account-circle
            </v-icon>
          </v-avatar>
          <v-badge
            bordered
            overlap
            bottom
            :color="
              $store.state.online_users.includes(item.guid.toString())
                ? 'green'
                : 'red'
            "
            offset-x="14"
            offset-y="-4"
            class="bdg"
          />
        </v-col>
        <v-col cols="10" class="text-truncate">
          <v-list-item-content
            @click="select_user(item)"
            class="d-inline-block text-truncate mt-1 pt-2"
            style="max-width: calc(100% - 14%)"
          >
            <v-list-item-title class="mt-1">
              <v-row no-gutters dense>
                <v-col cols="auto">
                  <h4>{{ item.contact }}</h4>
                </v-col>
                <v-col cols="auto">
                  <v-chip
                    v-if="item.statusObj"
                    x-small
                    class="mx-2"
                    outlined
                    dense
                    :color="item.statusObj.color || ''"
                  >
                    {{ item.statusObj.value }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-list-item-title>
            <v-list-item-subtitle>
              <span
                v-if="item.sender_type === 'admin'"
                style="color: #006064 !important"
                class="text--primary subtitle-2"
                >You</span
              >
              <span
                v-else
                style="color: #002b67 !important"
                class="text--primary subtitle-2"
                >{{ item.contact }}</span
              >
              &mdash;
              <span
                v-html="
                  typeof item.last_message === 'object'
                    ? $t(`messanger.dash.msg_types.${item.last_message.key}`)
                    : item.last_message
                "
              >
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-col>
      </v-row>
      <v-btn absolute right icon class="mobile_more_btn" @click="more(item)">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
      <v-btn
        absolute
        right
        icon
        class="mobile_box_btn"
        @click="toggleCheckbox(item)"
      >
        <v-icon :color="selected.includes(item.i_msg) ? 'primary' : ''">
          {{
            selected.includes(item.i_msg)
              ? `mdi-checkbox-marked-outline`
              : `mdi-checkbox-blank-outline`
          }}</v-icon
        >
      </v-btn>
    </v-list-item>
    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card max-width="375" class="mx-auto">
          <v-img
            src="https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png"
            height="300px"
            dark
          >
            <v-card-title>
              <v-btn dark icon @click="dialog = false">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>

              <v-spacer />

              <v-btn dark icon @click="see_infos(user_msg)">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-card-title>

            <v-spacer />
            <v-row class="mt-12 pt-11" justify="center">
              <v-col cols="auto" class="mt-12 text-center text-truncate">
                <v-card-title class="white--text text-center">
                  <div class="display-1 text-center">
                    {{ user_msg.contact }}
                  </div>
                </v-card-title>
              </v-col>
            </v-row>
          </v-img>

          <v-list three-line>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="indigo"> mdi-message-text </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`messanger.dash.table_head.last_msg`) }} :
                  </span>
                  <span> {{ user_msg.last_message }}</span>
                </v-list-item-subtitle>

                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`messanger.dash.table_head.date_sent`) }} :
                  </span>
                  <span> {{ user_msg.sent_at_value }}</span>
                </v-list-item-subtitle>

                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`messanger.dash.table_head.priority`) }} :
                  </span>
                  <span> {{ user_msg.priority ? "High" : "Unspecified" }}</span>
                </v-list-item-subtitle>

                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`messanger.dash.table_head.status`) }} :
                  </span>
                  <v-chip
                    v-if="user_msg.statusObj"
                    small
                    class="mb-2"
                    outlined
                    :color="user_msg.statusObj.color || ''"
                  >
                    {{ user_msg.statusObj.value }}</v-chip
                  >
                </v-list-item-subtitle>

                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`messanger.dash.table_head.status_email`) }} :
                  </span>
                  <v-chip
                    v-if="user_msg.EmailStatusObj"
                    small
                    class="mb-2"
                    outlined
                    :color="user_msg.EmailStatusObj.color || ''"
                  >
                    {{
                      user_msg.EmailStatusObj.value === "none"
                        ? "--"
                        : user_msg.EmailStatusObj.value
                    }}</v-chip
                  >
                </v-list-item-subtitle>

                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`messanger.dash.table_head.comments`) }} :
                  </span>
                  <span> {{ user_msg.AdminNote || "-" }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset />

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="indigo"> mdi-account </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`messanger.dash.table_head.online`) }} :
                  </span>
                  <v-icon
                    :color="
                      $store.state.online_users.includes(item.guid.toString())
                        ? 'green'
                        : '#e0e0e0'
                    "
                    size="20"
                    >mdi-record</v-icon
                  >
                </v-list-item-subtitle>
                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`users.dash.table_head.firstname`) }} :
                  </span>
                  <span> {{ user_msg.firstname || "-" }} </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`users.dash.table_head.lastname`) }} :
                  </span>
                  <span> {{ user_msg.email || "-" }} </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="my-2">
                  <span class="text--primary subtitle-2"
                    >{{ $t(`users.dash.table_head.lastname`) }} :
                  </span>
                  <span> {{ user_msg.email || "-" }} </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>
    </div>
  </v-list>
</template>

<script>
export default {
  name: "mobile_dash",
  data: () => ({
    colors: ["red", "pink", "cyan", "green"],
    loading: true,
    dialog: false,
    user_msg: {
      user_contact: "",
      msg: "",
      type: "",
    },
    pageCount: 0,
    call_btn: false,
  }),
  props: {
    index: null,
    item: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Array,
      default: () => [],
    },
    receiver_ids: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filteredDesserts() {
      return this.$store.state.messages.filter_rest;
    },
  },
  mounted: function () {},
  methods: {
    click_item() {
      // console.log('test');
    },
    toggleCheckbox(item) {
      if (!this.selected.includes(item.i_msg)) {
        this.selected.push(item.i_msg);
        this.receiver_ids.push(item.receiver);
      } else {
        const idx = this.selected.indexOf(item.i_msg);
        this.selected.splice(idx, 1);
        this.receiver_ids.splice(idx, 1);
      }
    },
    async paginate(val) {
      if (val == this.pageCount) {
        let cmp = this.$store.state.messages.filter_rest.length;
        this.$store.dispatch("setCloader", { showing: true });
        this.api_msg_pull = this.api_msg_pull + 1;
        await this.$store
          .dispatch("FETCH_MESSAGES", this.api_msg_pull)
          .then((r) => {
            this.$store.dispatch("setCloader", { showing: false });
            this.$vuetify.goTo(0);
          });
      }
    },
    updatePage(val) {
      this.page_infos = val;
    },
    see_infos(item) {
      this.call_btn = true;
      var user = item;
      // console.log("=>", user);
      this.$store.state.show.dash = false;
      this.$store.state.show.chat = false;
      this.$store.dispatch("FETCH_USER", user.receiver_id).then((response) => {
        this.$store.dispatch("setInfocard", {
          showing: true,
          id: user.receiver_id,
          user: user,
          from: "message",
        });
      });
    },
    more(item) {
      this.dialog = true;
      this.user_msg = item;
      // console.log(item);
    },
    avatar(item) {
      if (item.contact[0] === "#") return false;
      return true;
    },
    select_user(value) {
      this.$store.state.chat_user = value;
      // console.log("select", value.guid);
      this.$store.state.user_conversation_id = value.conversation_id.toString();
      this.$store.dispatch("FETCH_USER_MESSAGES", value.receiver_id);
      this.$socket.emit("SelectUser", value.guid, (data) => {
        if (typeof data === "string") {
          console.error(data);
        } else {
          console.log("user selected :", value.receiver_id, value.guid);
        }
      });
      this.$store.state.show.dash = false;
      this.$store.state.show.chat = true;
    },
  },
};
</script>
<style scoped>
.tile {
  border-top: 1px solid #e0e0e0;
}
.tile:hover {
  background: #ffffff;
}
.active {
  background: #00000024 !important;
  padding: 13px 21px;
}
.active .cor-title {
  color: #00000061;
}
.active .cor-body {
  color: #00000061;
}
.bdg .v-badge__badge {
  height: 14px;
  min-width: 14px;
}
.mobile_more_btn {
  right: 7px;
  top: 50%;
}
.mobile_box_btn {
  right: 7px;
  bottom: 50%;
}
</style>
